const PIPELINE_APPLICATION_TYPES = new Set([
  'development application',
  'complying development',
  'complying development cert',
  'complying development certificate',
]);

export function isPipelineApplicationType(applicationType) {
  const value = String(applicationType || '').trim().toLowerCase();
  return !value || PIPELINE_APPLICATION_TYPES.has(value);
}

export function getPipelineCost(row) {
  if (!isPipelineApplicationType(row?.application_type)) return null;
  const value = Number(row?.cost_of_development ?? row?.estimated_cost ?? 0);
  return Number.isFinite(value) && value >= 1000 ? value : null;
}

export function hasPipelineCost(row) {
  return getPipelineCost(row) !== null;
}

export function summarisePipelineValue(rows, { qualifierThreshold = 0.9 } = {}) {
  const safeRows = Array.isArray(rows) ? rows : [];
  let totalValue = 0;
  let valuedCount = 0;

  for (const row of safeRows) {
    const value = getPipelineCost(row);
    if (value === null) continue;
    totalValue += value;
    valuedCount += 1;
  }

  const totalCount = safeRows.length;
  const coverage = totalCount > 0 ? valuedCount / totalCount : 0;
  return {
    totalCount,
    valuedCount,
    totalValue,
    coverage,
    needsQualifier: totalCount > 0 && coverage < qualifierThreshold,
  };
}

export function formatPipelineMoney(value) {
  const amount = Number(value || 0);
  if (!amount) return '$0';
  if (amount >= 1000000000) return `$${(amount / 1000000000).toFixed(amount >= 10000000000 ? 0 : 1)}B`;
  if (amount >= 1000000) return `$${(amount / 1000000).toFixed(amount >= 100000000 ? 0 : 1)}M`;
  if (amount >= 1000) return `$${Math.round(amount / 1000)}K`;
  return `$${Math.round(amount).toLocaleString()}`;
}

export function pipelineValueQualifier(summary) {
  const totalCount = Number(summary?.totalCount || 0);
  const valuedCount = Number(summary?.valuedCount || 0);
  if (totalCount <= 0) return 'no DAs';
  if (valuedCount <= 0) return `0 of ${totalCount.toLocaleString()} DAs with declared value`;
  if (summary?.needsQualifier) {
    return `across ${valuedCount.toLocaleString()} of ${totalCount.toLocaleString()} DAs with declared value`;
  }
  return `across ${totalCount.toLocaleString()} DA${totalCount === 1 ? '' : 's'}`;
}
